import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "patient-bg" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientBackground',
  setup(__props) {

// Presentational only

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "patient-bg__photo" }, null, -1),
    _createElementVNode("div", { class: "patient-bg__overlay" }, null, -1)
  ]))]))
}
}

})